import { Component, OnInit, ElementRef, ViewChild, HostListener } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogsComponent } from '../dialogs/dialogs.component';
import { CommonService } from '../services/common.service';
import { FormGroup, FormBuilder,FormControl, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import {Location, Appearance} from '@angular-material-extensions/google-maps-autocomplete';
import PlaceResult = google.maps.places.PlaceResult;
import { constVariables } from "../constants/ConstantPath";
import { HotelhomeService } from '../hotelhome/services/hotelhome.service';
import { NgbDateStruct, NgbDate, NgbCalendar, NgbDateParserFormatter, NgbDatepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { PopupComponent } from '../dialogs/popup/popup.component';
import { GoogleForm } from "../shared/providers/map-form-fields";
import {MatDatepickerModule,MatCalendarCellCssClasses} from '@angular/material/datepicker';
@Component({
  selector: 'app-hotel-search',
  templateUrl: './hotel-search.component.html',
  styleUrls: ['./hotel-search.component.scss'],
  providers:[GoogleForm]
})
export class HotelSearchComponent implements OnInit {
	private searchData:any={};
	private searchDataSubscription;
	public hotelsData:any=[];
	public searchInProgress:boolean =false;
	public showLoader:boolean =false;
  public latitude: number;
  public longitude: number;
  public fromDate: NgbDate;
  public hoveredDate: NgbDate;
  public toDate: NgbDate;
  public toMinDate;
  public minDate;
  public searchForm: FormGroup;
  public searchFormData:any = {};
  public selectedDates:{start :'', end :''} ;
  public searchDateDisplayValue;
  Adults = [
    {viewValue: 'Adults-1', value: 1},
    {viewValue: 'Adults-2', value: 2},
    {viewValue: 'Adults-3', value: 3},
    {viewValue: 'Adults-4', value: 4},
    {viewValue: 'Adults-5', value: 5},
    {viewValue: 'Adults-6', value: 6}
  ];
  kids = [
    {viewValue: 'Kids-0', value: 0},
    {viewValue: 'Kids-1', value: 1},
    {viewValue: 'Kids-2', value: 2},
    {viewValue: 'Kids-3', value: 3},
    {viewValue: 'Kids-4', value: 4}
   
  ];
    private room_stay_from;
  private room_stay_to;

  constructor(
    private commonService : CommonService,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private hotelhomeService: HotelhomeService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private config: NgbDatepickerConfig,
    public googleForm: GoogleForm,
  ) { 
     if(localStorage.getItem('searchData') !== undefined && localStorage.getItem('searchData') !== '' ){
       	this.searchInProgress = true;
       	this.showLoader =true;
     		this.searchData = JSON.parse(localStorage.getItem('searchData'));
        this.selectedDates = {start:this.searchData.room_stay_from, end: this.searchData.room_stay_to};
        this.searchDateDisplayValue = this.searchData.room_stay_from+'-'+this.searchData.room_stay_to;
        this.longitude = this.searchData.longitude;
        this.latitude = this.searchData.latitude;
         this.minDate = moment().format('YYYY-MM-DD');
         let room_stay_from = this.searchData.room_stay_from.split('-');
        this.room_stay_from =room_stay_from[2]+'-'+room_stay_from[0]+'-'+room_stay_from[1];   
        let room_stay_to = this.searchData.room_stay_to.split('-');
        this.room_stay_to = room_stay_to[2]+'-'+room_stay_to[0]+'-'+room_stay_to[1];
        let toMinDate = new Date(this.room_stay_from);
        toMinDate.setDate(toMinDate.getDate() + 1);
        this.toMinDate = moment(toMinDate).format('YYYY-MM-DD');
        let data = {
          address:this.searchData.location,
          latitude:this.searchData.latitude,
          longitude:this.searchData.longitude,
          room_stay_from:this.searchData.room_stay_from,
          room_stay_to:this.searchData.room_stay_to,
          adults:this.searchData.adults,
          child:this.searchData.child
        };
     		this.searchHotel(data);
    }
  }

  /// For searching Hotel (Main Request)
  searchHotel(data){
    this.searchInProgress = true;
    this.showLoader =true;
    this.commonService.getHotels(data).then((hotels:any)=>{
          this.hotelsData = hotels;
          this.searchInProgress = false;
          this.showLoader = false;
          let searchData ={
            room_stay_from: data.room_stay_from,
            room_stay_to : data.room_stay_to,
            adults : data.adults,
            child : data.child,
            latitude : data.latitude,
            longitude : data.longitude,
            location : data.address
          };
          localStorage.setItem('searchData',JSON.stringify(searchData));
      });
  }

  //Searching Hotel through form
  searchHotelRequest(){
    console.log(this.searchForm.value);
    let searchData = this.searchForm.value;
    let data = {
      room_stay_from : moment(searchData.room_stay_from).format('MM-DD-YYYY'),
      room_stay_to : moment(searchData.room_stay_to).format('MM-DD-YYYY'),
      address : searchData.destination,
      latitude : this.latitude,
      longitude : this.longitude,
      adults : searchData.adults,
      child : searchData.child
    };
    this.searchData = data;
    this.searchHotel(data);
  }

  ngOnInit() {
    this.searchForm = this.fb.group({
      destination: [this.searchData.location, [Validators.required]],
      room_stay_from: [this.room_stay_from, [Validators.required]],
      room_stay_to: [this.room_stay_to, [Validators.required]],
      adults: [this.searchData.adults, [Validators.required]],
      child: [this.searchData.child, [Validators.required]]
    });

    let toMinDate = new Date(this.searchData.room_stay_from);
    toMinDate.setDate(toMinDate.getDate() + 1);
    this.toMinDate = moment(toMinDate).format('YYYY-MM-DD');
  }

  navigatetorooms(hotel){
    console.log(hotel);
    this.router.navigate(['/search-results/'+hotel+'/'+this.searchData.room_stay_from+'/'+this.searchData.room_stay_to+'/'+this.searchData.adults+"/"+this.searchData.child]);
    // localStorage.removeItem('searchData');
  }


  // Autocomplete address field in register form
  onAutocompleteSelected(result: PlaceResult) {
    let addressValue = this.commonService.makeAutoCompleteAddress(result);
    this.searchForm.patchValue({address: addressValue});    
    this.searchForm.value.destination = addressValue;
  }

  onLocationSelected(location: Location) {
      this.latitude = location.latitude;
      this.longitude = location.longitude;
  }

  

    /**********************************
  * Update roomstayFrom and To dates*
  **********************************/
  changeRoomStayFromDate() {
    let from = moment(this.searchForm.value.room_stay_from).format('YYYY-MM-DD');
    let toDate = new Date(from);
    toDate.setDate(toDate.getDate() + 2);
    this.searchForm.setValue({
      destination :this.searchForm.value.destination,
      room_stay_from : from,
      room_stay_to : moment(toDate).format('YYYY-MM-DD'),
      adults: this.searchForm.value.adults,
      child: this.searchForm.value.child
    });

    from = moment(this.searchForm.value.room_stay_from).format('YYYY-MM-DD');
    toDate = new Date(from);
    toDate.setDate(toDate.getDate() + 1);
    this.toMinDate = moment(toDate).format('YYYY-MM-DD');
  }

}
